import { useRef, useState } from "react";
import { useResizeObserver } from "@hooks";

export const useTableOverflowChecker = (
  headerRef,
  onResize,
  onScroll,
  checkByScrollWidth,
) => {
  const [ isTableContentOverflowing, setOverflowing ] = useState(false);
  const [ containerWidth, setContainerWidth ] = useState();
  const [ scrollWidth, setScrollWidth ] = useState();
  const [ scrollReachedStart, setReachedStart ] = useState(false);
  const [ scrollReachedEnd, setReachedEnd ] = useState(false);
  
  const containerRef = useRef(null);
  
  const handleScroll = () => {
    if(!containerRef.current) return;
    const s = containerRef.current.scrollLeft;
    const w = containerRef.current.scrollWidth - containerRef.current.offsetWidth;
    if(s <= 0 || scrollReachedStart)
      setReachedStart(s <= 0)
    if(s >= w || scrollReachedEnd)
      setReachedEnd(s >= w)
    
    onScroll?.(s, w);
  }

  const handleResize = () => {
    if(!containerRef.current) return;
    let o = false;
    if(checkByScrollWidth)
      o = containerRef.current.offsetWidth < containerRef.current.scrollWidth;
    else if (headerRef) {
      o = containerRef.current.offsetWidth < headerRef.offsetWidth;
      setScrollWidth(headerRef.offsetWidth);
    }

    if (o !== isTableContentOverflowing)
      setOverflowing(o);

    setContainerWidth(containerRef.current.offsetWidth);
    onResize?.(containerRef.current.offsetWidth);
    
    handleScroll();
  };
  
  useResizeObserver(handleResize, containerRef.current);
  
  return {
    ref: containerRef,
    onScroll: handleScroll,
    onResize: handleResize,
    isTableContentOverflowing,
    isScrolled: !scrollReachedStart,
    isEndScrolled: !scrollReachedEnd,
    containerWidth,
    scrollWidth,
    scrollButtonProps: {
      containerRef,
      scrollReachedStart,
      scrollReachedEnd,
    }
  };
};
